export default "__VITE_PUBLIC_ASSET__e200f8f2__"